exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".org-name[data-v-f3cf8d28]{font-size:14px}.van-collapse-item .van-cell[data-v-f3cf8d28]{background-color:#969799}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3cf8d28","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/contractor/ContractorGroupListItemCompany.vue
// module id = 898
// module chunks = 0